export default function has(set, item) {
  return set.has(item);
}